<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1"
           [routerLink]="['/remote-command/token-load/clear-credit']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">
        {{ "REMOTECOMMAND_CLEARCREDIT" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "CLEARCREDIT_SUBTITLE" | translate }}
      </h6>
    </div>
  </div>

  <form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="meterNo">
        {{
        "DEVICESETUP_METERNO" | translate
        }}
      </label>
      <div class="form-input">
        <input id="meterNo"
               [(ngModel)]="data.meterNo"
               #meterNo="ngModel"
               name="meterNo"
               type="text"
               pattern="^[0-9]+$"
               required />
        @if (crudform.submitted && meterNo.invalid) {
        <div class="validation-error">
          {{
 "DEVICESETUP_METERNO" | translate
          }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
        }
        @if (!data.meterNo || data.meterNo.trim() === "") {
        <div class="validation-instruction">
          {{ "DEVICESETUP_METERNODESC" | translate }}
        </div>
        } @else if (meterNo.invalid && meterNo.errors?.["pattern"]) {
        <div class="validation-error">
          {{ "METERNUMBER_ERROR" | translate }}
        </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="token">
        {{
        "CLEARCREDITSETUP_STSTOKEN" | translate
        }}
      </label>
      <div class="form-input">
        <input id="ststoken"
               [(ngModel)]="data.token"
               #ststoken="ngModel"
               name="ststoken"
               type="text"
               pattern="^(\d{20}|\d{4}([\- ])\d{4}\2\d{4}\2\d{4}\2\d{4})$"
               required />
        @if (
        ststoken.invalid && ststoken.touched && ststoken.errors?.["pattern"]
        ) {
        <div class="validation-error">
          {{ "CLEARCREDITSETUP_STSTOKENERROR" | translate }}
        </div>
        } @else if (!ststoken.valid && !crudform.submitted) {
        <div class="validation-instruction">
          {{ "CLEARCREDITSETUP_STSTOKENDESC" | translate }}
        </div>
        } @else if (crudform.submitted && ststoken.invalid) {
        <div class="validation-error">
          {{
 "CLEARCREDITSETUP_STSTOKEN" | translate
          }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
        }
      </div>
    </div>

    <div class="horizontal-line"></div>

    <div class="form-item-button">
      <button class="button-submit" [disabled]="crudform.invalid" type="submit">
        {{ "CONTINUE" | translate }}
      </button>
    </div>
  </form>
</div>
